(function () {
  if (window.__b2bQtySyncLoaded) return;
  window.__b2bQtySyncLoaded = true;

  function getVariantsData(section) {
    var el = section.querySelector('[data-variant-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptionValues(section) {
    var checked = section.querySelectorAll('[data-variant-input]:checked');
    var values = [];
    checked.forEach(function (input) {
      var idxAttr = input.getAttribute('data-index');
      if (!idxAttr) return;
      var index = parseInt(idxAttr.replace('option', ''), 10) - 1;
      values[index] = input.value;
    });
    return values;
  }

  function findMatchingVariant(variants, values) {
    return variants.find(function (v) {
      return (
        (values[0] === undefined || v.option1 === values[0]) &&
        (values[1] === undefined || v.option2 === values[1]) &&
        (values[2] === undefined || v.option3 === values[2])
      );
    });
  }

  function updateQuantitySelector(section, variantId) {
    var handle = section.getAttribute('data-product-handle');
    var sectionId = section.getAttribute('data-section-id');
    if (!handle || !sectionId || !variantId) return;

    var url =
      '/products/' +
      handle +
      '?variant=' +
      variantId +
      '&section_id=' +
      encodeURIComponent(sectionId);

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newWrap = doc.querySelector('[data-b2b-quantity-wrap]');
        var oldWrap = section.querySelector('[data-b2b-quantity-wrap]');
        if (newWrap && oldWrap) {
          oldWrap.replaceWith(newWrap);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (evt) {
    if (!evt.target || !evt.target.matches || !evt.target.matches('[data-variant-input]')) return;
    var section = evt.target.closest('[data-section-type="product"]');
    if (!section) return;

    var variants = getVariantsData(section);
    if (!variants) return;
    var values = getSelectedOptionValues(section);
    var variant = findMatchingVariant(variants, values);
    if (!variant) return;

    setTimeout(function () {
      updateQuantitySelector(section, variant.id);
    }, 80);
  });
})();
